import z from 'zod';

export const siteSearchTypeaheadValueSchema = z.object({
  href: z.string(),
  title: z.string(),
  type: z.union([z.literal('link'), z.literal('query')]),
});

export type SiteSearchTypeaheadValue = z.infer<typeof siteSearchTypeaheadValueSchema>;
